import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font, radius, shadow } from '~styles/theme.stylex';
const DESKTOP = '@media (min-width: 60rem)';
const REDUCED = '@media (prefers-reduced-motion: reduce)';
const DISPLAY = "'Bricolage Grotesque', 'Poppins', system-ui, sans-serif";
export const styles = {
  page: {
    maxWidth: "xzsb0xr",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  hero: {
    display: "x78zum5 x2399xu",
    flexDirection: "xdt5ytf",
    gridTemplateColumns: "x1noms9b x13larzw",
    alignItems: "x6s0dn4",
    columnGap: "x1nml6z7",
    rowGap: "x1d474pu",
    paddingTop: "x128v7jw x2jnpi",
    paddingBottom: "x117aka2 x1jqcxhh",
    $$css: true
  },
  eyebrow: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: "x1gr9t9r",
    fontSize: "x1dcheo9",
    fontWeight: "xlr2uoh",
    letterSpacing: "x1dor1uw",
    textTransform: "xtvhhri",
    color: "x1gonuu0",
    $$css: true
  },
  h1: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontFamily: "x1oewl91",
    fontWeight: "xuv8nkb",
    fontSize: "x1iv1qll xkviece",
    lineHeight: "xqahw4z",
    letterSpacing: "x72az59",
    color: "xtt1gjl",
    $$css: true
  },
  h1Accent: {
    color: "x1gonuu0",
    $$css: true
  },
  heroSub: {
    marginTop: "x1c4vshn",
    marginBottom: "xat24cr",
    fontSize: "x1lkfr7t",
    lineHeight: "x1evy7pa",
    color: "xarw3lm",
    maxWidth: "xc0i79g",
    $$css: true
  },
  heroActions: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    alignItems: "x6s0dn4",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    marginTop: "x1cl2iem",
    $$css: true
  },
  primaryCta: {
    backgroundColor: "xwk94rn",
    color: "x6n9e3r",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    fontWeight: "xlr2uoh",
    fontSize: "x1lkfr7t",
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "xzsmjar",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    boxShadow: "x16tpqxm",
    $$css: true
  },
  ghostCta: {
    color: "xtt1gjl",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    fontWeight: "xlr2uoh",
    fontSize: "x1lkfr7t",
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  section: {
    paddingBlock: "xic3azd x1hpntiw",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  h2: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: "x1t84w78",
    fontFamily: "x1oewl91",
    fontWeight: "x1xlr1w8",
    fontSize: "x1q74xe4 x12kjtfe",
    lineHeight: "x1159mfc",
    letterSpacing: "xjat59b",
    color: "xtt1gjl",
    $$css: true
  },
  h3: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontFamily: "x1oewl91",
    fontWeight: "x1xlr1w8",
    fontSize: "x1603h9y",
    color: "xtt1gjl",
    $$css: true
  },
  compare: {
    display: "xrvj5dj",
    gridTemplateColumns: "x1y6fwsi xs2b3ki",
    gap: "xru8eyw",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  compareCard: {
    borderRadius: "x1j6x5gx",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "xr6jg0x",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  compareOld: {
    backgroundColor: "x19l0dny",
    transitionProperty: "x6o7n8i",
    transitionDuration: "x1fkkkjs x12w9bfk",
    transitionTimingFunction: "xwji4o3",
    $$css: true
  },
  compareOldSeen: {
    opacity: "xwq05k6",
    transform: "x1ehq0ju",
    $$css: true
  },
  compareNew: {
    backgroundColor: "x15xno7f",
    borderEndStartRadius: "xt6ftvx",
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    boxShadow: "x13g88js",
    transitionProperty: "x16n73rl",
    transitionDuration: "x1fkkkjs x12w9bfk",
    transitionTimingFunction: "xwji4o3",
    $$css: true
  },
  compareNewSeen: {
    transform: "x1wx64ow",
    boxShadow: "xrrsowq",
    $$css: true
  },
  compareTag: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    fontSize: "x1dcheo9",
    fontWeight: "xlr2uoh",
    letterSpacing: "x2ujxvm",
    textTransform: "xtvhhri",
    color: "xarw3lm",
    $$css: true
  },
  compareTagNew: {
    color: "x1gonuu0",
    $$css: true
  },
  compareQuote: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontFamily: "x1oewl91",
    fontWeight: "x1s688f",
    fontSize: "x1603h9y x1l2chto",
    lineHeight: "x132q4wb",
    color: "xtt1gjl",
    $$css: true
  },
  compareQuoteOld: {
    color: "x1fqc3c1",
    fontWeight: "x1s688f",
    $$css: true
  },
  compareNote: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x6u19be",
    color: "xarw3lm",
    $$css: true
  },
  compareReplies: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    marginTop: "xr1yuqi",
    $$css: true
  },
  replyText: {
    fontSize: "x6u19be",
    fontWeight: "xlr2uoh",
    color: "xw6893c",
    marginLeft: "x4aigyd",
    marginInlineStart: null,
    marginInlineEnd: null,
    $$css: true
  },
  differenceStatement: {
    margin: "x1ghz6dp",
    marginBlock: null,
    marginBottom: null,
    marginTop: "x1hpjnmm",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    maxWidth: "x19pzynt",
    textAlign: "x2b8uid",
    fontFamily: "x1oewl91",
    fontWeight: "x1s688f",
    fontSize: "x1603h9y x1l2chto",
    lineHeight: "xwn7fz2",
    color: "xtt1gjl",
    $$css: true
  },
  quote: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginBottom: null,
    marginTop: "xfo0wrl",
    textAlign: "x2b8uid",
    minHeight: "xmqjtvy xw2o8ci",
    $$css: true
  },
  quoteSwap: {
    opacity: "x1hc1fzr",
    transform: "x1c071of",
    transitionProperty: "x6o7n8i",
    transitionDuration: "xippbsu x12w9bfk",
    transitionTimingFunction: "xwji4o3",
    $$css: true
  },
  quoteHidden: {
    opacity: "xg01cxk",
    transform: "xnu4gnj",
    $$css: true
  },
  quoteText: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontFamily: "x1oewl91",
    fontWeight: "x1xlr1w8",
    fontStyle: "x1k4tb9n",
    fontSize: "xngnso2 x1il3m6y",
    lineHeight: "x132q4wb",
    color: "xtt1gjl",
    $$css: true
  },
  quoteAuthor: {
    marginTop: "xhj8ucd",
    fontSize: "x6u19be",
    color: "xarw3lm",
    $$css: true
  },
  stepNum: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    width: "xvm51jw",
    height: "xwaiz5r",
    borderRadius: "x15fclwp",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "x15xno7f",
    color: "x1gonuu0",
    fontFamily: "x1oewl91",
    fontWeight: "xuv8nkb",
    fontSize: "x1603h9y",
    $$css: true
  },
  stepText: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x6u19be",
    lineHeight: "x1evy7pa",
    color: "xarw3lm",
    flexGrow: "x1iyjqo2",
    $$css: true
  },
  leg: {
    display: "x78zum5 x2399xu",
    flexDirection: "xdt5ytf",
    gridTemplateColumns: "x1noms9b xieafq8",
    columnGap: "xrnao7d",
    rowGap: "x1d474pu",
    alignItems: "x6s0dn4",
    maxWidth: "x1l59rab",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    paddingBlock: "x1yb22fu",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  legReverse: {
    gridTemplateColumns: "x1noms9b x184urxs",
    $$css: true
  },
  legCopyReverse: {
    gridColumn: "xm5moh1 x1tiv5ds",
    gridColumnStart: null,
    gridColumnEnd: null,
    gridRow: "x15daork xq17dsj",
    gridRowStart: null,
    gridRowEnd: null,
    $$css: true
  },
  legShotReverse: {
    gridColumn: "xm5moh1 x1qjfwf0",
    gridColumnStart: null,
    gridColumnEnd: null,
    gridRow: "x15daork xq17dsj",
    gridRowStart: null,
    gridRowEnd: null,
    $$css: true
  },
  legTitle: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: "xj1urod",
    marginBottom: "x1gr9t9r",
    fontFamily: "x1oewl91",
    fontWeight: "x1xlr1w8",
    fontSize: "xngnso2 xh38obv",
    lineHeight: "x1159mfc",
    color: "xtt1gjl",
    $$css: true
  },
  legText: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x1lkfr7t",
    lineHeight: "x1evy7pa",
    color: "xarw3lm",
    maxWidth: "x1ptgtm5",
    $$css: true
  },
  legShot: {
    display: "x1lliihq",
    width: "xh8yej3",
    maxWidth: "x8z6zn4",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    borderRadius: "x1j6x5gx",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x2rc37l",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    boxShadow: "x18xvf5j",
    $$css: true
  },
  legShotA: {
    transform: "xuuhc61",
    $$css: true
  },
  legShotB: {
    transform: "xf5r5xt",
    $$css: true
  },
  destination: {
    marginInline: "x1cafle",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginTop: "x1cl2iem",
    backgroundColor: "x1qq9o34",
    paddingBlock: "xic3azd x1hpntiw",
    paddingTop: null,
    paddingBottom: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    $$css: true
  },
  destinationInner: {
    maxWidth: "xzsb0xr",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    textAlign: "x2b8uid",
    $$css: true
  },
  destinationChip: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    backgroundColor: "x1xaky2g",
    color: "x1gonuu0",
    borderRadius: "x1w8o7ox",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingBlock: "x18g2hj5",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "x13s4r1c",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    fontSize: "x1dcheo9",
    fontWeight: "xlr2uoh",
    letterSpacing: "x2ujxvm",
    textTransform: "xtvhhri",
    boxShadow: "x13g88js",
    $$css: true
  },
  destinationTitle: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginBottom: null,
    marginTop: "x1c4vshn",
    fontFamily: "x1oewl91",
    fontWeight: "xuv8nkb",
    fontSize: "x13wtedm xhzekow",
    lineHeight: "xqahw4z",
    letterSpacing: "x72az59",
    color: "xtt1gjl",
    $$css: true
  },
  dedication: {
    marginTop: "x1o5ky9o",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    maxWidth: "x19pysoa",
    textAlign: "x2b8uid",
    fontStyle: "x1k4tb9n",
    fontSize: "x6u19be",
    lineHeight: "x1dbl2gt",
    color: "xarw3lm",
    $$css: true
  },
  destinationSub: {
    margin: "x1ghz6dp",
    marginBlock: null,
    marginBottom: null,
    marginTop: "xj1urod",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    maxWidth: "x19pysoa",
    fontSize: "x1lkfr7t",
    lineHeight: "x1evy7pa",
    color: "xarw3lm",
    $$css: true
  },
  manifesto: {
    textAlign: "x2b8uid",
    $$css: true
  },
  manifestoTitle: {
    fontSize: "x579bpy xcr2re2",
    marginBottom: "xyi6m4r",
    $$css: true
  },
  manifestoText: {
    margin: "x1ghz6dp",
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    maxWidth: "x19pzynt",
    fontSize: "x1lkfr7t",
    lineHeight: "x1evy7pa",
    color: "xarw3lm",
    $$css: true
  },
  safetyLead: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: "x1sytv6u",
    marginBottom: "x1t84w78",
    maxWidth: "x19pzynt",
    fontSize: "x1lkfr7t",
    lineHeight: "x1evy7pa",
    color: "xarw3lm",
    $$css: true
  },
  safetyGrid: {
    display: "xrvj5dj",
    gridTemplateColumns: "x1y6fwsi x1jkb04u",
    gap: "xru8eyw",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  safetyCard: {
    backgroundColor: "x80m72e",
    borderRadius: "x1j6x5gx",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "xr6jg0x",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  safetyIconBlue: {
    color: "x1bj2zf7",
    $$css: true
  },
  safetyIconCoral: {
    color: "x1gonuu0",
    $$css: true
  },
  safetyIconCyan: {
    color: "x18yk8ih",
    $$css: true
  },
  ctaPanel: {
    backgroundColor: "xwk94rn",
    borderRadius: "x1j6x5gx",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingBlock: "xic3azd x1hpntiw",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "xw4edqq",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    textAlign: "x2b8uid",
    $$css: true
  },
  ctaTitle: {
    color: "x6n9e3r",
    marginBottom: "x1nhhxel",
    $$css: true
  },
  storeRow: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    justifyContent: "xl56j7k",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  storeButton: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    backgroundColor: "x1xaky2g",
    color: "xtt1gjl",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    cursor: "x1ypdohk",
    font: "xln7xf2",
    fontFamily: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontVariantAlternates: null,
    fontVariantCaps: null,
    fontVariantEastAsian: null,
    fontVariantEmoji: null,
    fontVariantLigatures: null,
    fontVariantNumeric: null,
    fontVariantPosition: null,
    lineHeight: null,
    fontWeight: "xlr2uoh",
    fontSize: "x1lkfr7t",
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "xzsmjar",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  },
  ctaNote: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginBottom: null,
    marginTop: "xwg69jb",
    fontSize: "x6u19be",
    color: "xs6ipml",
    $$css: true
  },
  route: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    marginBlock: "xc7kcmm",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  routeSvg: {
    width: "xex909m",
    height: "x1isdrda",
    $$css: true
  },
  routePin: {
    color: "x1gonuu0",
    marginTop: "x15s5u4p",
    $$css: true
  },
  footer: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    alignItems: "x6s0dn4",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    paddingBlock: "x18mflkt",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  footerText: {
    fontSize: "x6u19be",
    color: "xarw3lm",
    $$css: true
  },
  footerLinks: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "x19gx3kl",
    rowGap: null,
    columnGap: null,
    fontSize: "x6u19be",
    $$css: true
  },
  footerLink: {
    color: "xarw3lm",
    $$css: true
  }
};